/** Shared hero background used on listing pages (verified 200 on Unsplash). */
export const HERO_IMAGE_URL =
  "https://images.unsplash.com/photo-1506126613408-eca07ce68773?auto=format&fit=crop&q=80&w=2070";
